<h3 mat-dialog-title>{{ this.data.auditTitle }}</h3>
<div *ngIf="!isLoading" fxLayout="column" class="cm">
  <ng-container *ngIf="auditResponse.length > 0; else noAuditTrailInformation">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <span><b>Showing Last {{ numberRecords }}</b></span>
      <div fxLayoutGap="5pt" fxLayoutAlign="center center">
        <span>Last:</span>
        <mat-icon class="clickable material-icons-outlined" (click)="auditListSlice(5)">replay_5</mat-icon>
        <mat-icon class="clickable material-icons-outlined" (click)="auditListSlice(10)">replay_10</mat-icon>
        <mat-icon class="clickable material-icons-outlined" (click)="auditListSlice(30)">replay_30</mat-icon>
      </div>
    </div>
    <br>
    <div fxLayout="column" *ngIf="data.auditPath === 'CustomerAccount'">
      <div fxLayout="row" fxLayoutGap="5px" class="table-headers">
        <div fxFlex="7"><span><b>Operation</b></span></div>
        <div fxFlex="18"><span><b>Customer Name</b></span></div>
        <div fxFlex="12.5"><span><b>Business Unit</b></span></div>
        <div fxFlex="12.5"><span><b>Reporting Group</b></span></div>
        <div fxFlex="18"><span><b>Sales Agent</b></span></div>
        <div fxFlex="20"><span><b>Relationship Manager</b></span></div>
        <div fxFlex="5"><span><b>Status</b></span></div>
        <div fxFlex="7"><span><b>Federal EIN</b></span></div>
      </div>
      <div class="scroll-audit-trail">
        <div *ngFor="let account of auditResponseAccount">
          <div fxLayout="row" fxLayoutGap="5px" class="py-5">
            <div fxFlex="7"><span>{{ account.operation }}</span></div>
            <div fxFlex="18"><span>{{ account.auditData.customerName }}</span></div>
            <div fxFlex="12.5"><span>{{ account.auditData.businessUnit }}</span></div>
            <div fxFlex="12.5"><span>{{ account.auditData.reportingGroup }}</span></div>
            <div fxFlex="18"><span>{{ account.auditData.salesAgent }}</span></div>
            <div fxFlex="20"><span>{{ account.auditData.relationshipManager }}</span></div>
            <div fxFlex="5"><span>{{ account.auditData.status }}</span></div>
            <div fxFlex="7"><span>{{ account.auditData.federalEIN }}</span></div>
          </div>
          <mat-divider></mat-divider>
        </div>
      </div>
    </div>
    <div fxLayout="column" *ngIf="data.auditPath === 'CustomerAddress'">
      <div fxLayout="row" fxLayoutGap="5px" class="table-headers">
        <div fxFlex="7"><span><b>Operation</b></span></div>
        <div fxFlex="12.5"><span><b>Address Type</b></span></div>
        <div fxFlex="20.5"><span><b>Address 1</b></span></div>
        <div fxFlex="12.5"><span><b>Address 2</b></span></div>
        <div fxFlex="12.5"><span><b>City</b></span></div>
        <div fxFlex="10"><span><b>State</b></span></div>
        <div fxFlex="12.5"><span><b>Zip</b></span></div>
        <div fxFlex="12.5"><span><b>Country</b></span></div>
      </div>
      <div class="scroll-audit-trail">
        <div *ngFor="let address of auditResponseAddress">
          <div fxLayout="row" fxLayoutGap="5px" class="py-5">
            <div fxFlex="7"><span>{{ address.operation }}</span></div>
            <div fxFlex="12.5"><span>{{ address.auditData.addressType }}</span></div>
            <div fxFlex="20.5"><span>{{ address.auditData.address1 }}</span></div>
            <div fxFlex="12.5"><span>{{ address.auditData.address2 }}</span></div>
            <div fxFlex="12.5"><span>{{ address.auditData.city }}</span></div>
            <div fxFlex="10"><span>{{ address.auditData.state }}</span></div>
            <div fxFlex="12.5"><span>{{ address.auditData.zip }}</span></div>
            <div fxFlex="12.5"><span>{{ address.auditData.country }}</span></div>
          </div>
          <mat-divider></mat-divider>
        </div>
      </div>
    </div>
    <div fxLayout="column" *ngIf="data.auditPath === 'CustomerContact'">
      <div fxLayout="row" fxLayoutGap="5px" class="table-headers">
        <div fxFlex="6"><span><b>Operation</b></span></div>
        <div fxFlex="10"><span><b>Contact Type</b></span></div>
        <div fxFlex="7"><span><b>First Name</b></span></div>
        <div fxFlex="7"><span><b>Last Name</b></span></div>
        <div fxFlex="11"><span><b>Address 1</b></span></div>
        <div fxFlex="6"><span><b>Address 2</b></span></div>
        <div fxFlex="22"><span><b>Email</b></span></div>
        <div fxFlex="8"><span><b>Phone</b></span></div>
        <div fxFlex="5"><span><b>FAX</b></span></div>
        <div fxFlex="7"><span><b>City</b></span></div>
        <div fxFlex="3"><span><b>State</b></span></div>
        <div fxFlex="5"><span><b>Zip</b></span></div>
        <div fxFlex="3"><span><b>Country</b></span></div>
      </div>
      <div class="scroll-audit-trail">
        <div *ngFor="let contact of auditResponseContact">
          <div fxLayout="row" fxLayoutGap="5px" class="py-5">
            <div fxFlex="6"><span>{{ contact.operation }}</span></div>
            <div fxFlex="10"><span>{{ contact.auditData.contactType }}</span></div>
            <div fxFlex="7"><span>{{ contact.auditData.firstName }}</span></div>
            <div fxFlex="7"><span>{{ contact.auditData.lastName }}</span></div>
            <div fxFlex="11"><span>{{ contact.auditData.address1 }}</span></div>
            <div fxFlex="6"><span>{{ contact.auditData.address2 }}</span></div>
            <div fxFlex="22"><span><b>{{ contact.auditData.email }}</b></span></div>
            <div fxFlex="8"><span><b>{{ contact.auditData.phone }}</b></span></div>
            <div fxFlex="5"><span><b>{{ contact.auditData.fax }}</b></span></div>
            <div fxFlex="7"><span>{{ contact.auditData.city }}</span></div>
            <div fxFlex="3"><span>{{ contact.auditData.state }}</span></div>
            <div fxFlex="5"><span>{{ contact.auditData.zip }}</span></div>
            <div fxFlex="3"><span>{{ contact.auditData.country }}</span></div>
          </div>
          <mat-divider></mat-divider>
        </div>
      </div>
    </div>
    <div fxLayout="column" *ngIf="data.auditPath === 'CustomerPaymentTerm'">
      <div fxLayout="row" fxLayoutGap="5px" class="table-headers">
        <div fxFlex="25"><span><b>Operation</b></span></div>
        <div fxFlex="25"><span><b>Payment Terms</b></span></div>
        <div fxFlex="25"><span><b>Payment Terms Approval By</b></span></div>
        <div fxFlex="25"><span><b>Payment Terms Approval Date</b></span></div>
      </div>
      <div class="scroll-audit-trail">
        <div *ngFor="let paymentTerm of auditResponsePaymentTerms">
          <div fxLayout="row" fxLayoutGap="5px" class="py-5">
            <div fxFlex="25"><span>{{ paymentTerm.operation }}</span></div>
            <div fxFlex="25"><span>{{ paymentTerm.auditData.paymentTerms }}</span></div>
            <div fxFlex="25"><span>{{ paymentTerm.auditData.paymentTermsApprovalBy }}</span></div>
            <div fxFlex="25"><span>{{ paymentTerm.auditData.paymentTermsApprovalDate | date: 'MM/dd/yyyy' }}</span></div>
          </div>
          <mat-divider></mat-divider>
        </div>
      </div>
    </div>
    <div fxLayout="column" *ngIf="data.auditPath === 'CustomerCreditManagement'">
      <div fxLayout="row" fxLayoutGap="5px" class="table-headers">
        <div fxFlex="10"><span><b>Operation</b></span></div>
        <div fxFlex="10"><span><b>Credit Limit</b></span></div>
        <div fxFlex="14"><span><b>Credit Limit Mgt Active</b></span></div>
        <div fxFlex="18"><span><b>Credit Warning Percentage</b></span></div>
        <div fxFlex="18"><span><b>Credit Limit Eff Date</b></span></div>
        <div fxFlex="14"><span><b>Credit Limit Approval By</b></span></div>
        <div fxFlex="14"><span><b>Credit Limit Approval Date</b></span></div>
      </div>
      <div class="scroll-audit-trail">
        <div *ngFor="let credit of auditResponseCreditManagement">
          <div fxLayout="row" fxLayoutGap="5px" class="py-5">
            <div fxFlex="10"><span>{{ credit.operation }}</span></div>
            <div fxFlex="10"><span>{{ credit.auditData.creditLimit }}</span></div>
            <div fxFlex="14"><span>{{ credit.auditData.creditLimitMgtActive }}</span></div>
            <div fxFlex="18"><span>{{ credit.auditData.creditWarningPercentage }}</span></div>
            <div fxFlex="18"><span>{{ credit.auditData.creditLimitEffDate | date: 'MM/dd/yyyy' }}</span></div>
            <div fxFlex="14"><span>{{ credit.auditData.creditLimitApprovalBy }}</span></div>
            <div fxFlex="14"><span>{{ credit.auditData.creditLimitApprovalDate | date: 'MM/dd/yyyy' }}</span></div>
          </div>
          <mat-divider></mat-divider>
        </div>
      </div>
    </div>
    <div fxLayout="column" *ngIf="data.auditPath === 'CustomerInvoice'">
      <div fxLayout="row" fxLayoutGap="5px" class="table-headers text-centered">
        <div fxFlex="5"><span><b>Operation</b></span></div>
        <div fxFlex="7"><span><b>Billing Period</b></span></div>
        <div fxFlex="10"><span><b>Invoice Template</b></span></div>
        <div fxFlex="9"><span><b>Invoice Per Load</b></span></div>
        <div fxFlex="4"><span><b>R. POD</b></span></div>
        <div fxFlex="4"><span><b>R. BOL</b></span></div>
        <div fxFlex="9"><span><b>R. Physical POD</b></span></div>
        <div fxFlex="9"><span><b>Trans Detail Rpt</b></span></div>
        <div fxFlex="7"><span><b>Acct Dist Rpt</b></span></div>
        <div fxFlex="4"><span><b>A. POD</b></span></div>
        <div fxFlex="4"><span><b>A. BOL</b></span></div>
        <div fxFlex="19"><span><b>R. Manual Invoice Review</b></span></div>
        <div fxFlex="9"><span><b>Next Invoice Date</b></span></div>
      </div>
      <div class="scroll-audit-trail">
        <div *ngFor="let invoice of auditResponseInvoice">
          <div fxLayout="row" fxLayoutGap="5px" class="py-5 text-centered">
            <div fxFlex="5"><span>{{ invoice.operation }}</span></div>
            <div fxFlex="7"><span>{{ invoice.auditData.billingPeriodName }}</span></div>
            <div fxFlex="10"><span>{{ invoice.auditData.invoiceTemplateDescription }}</span></div>
            <div fxFlex="9"><span>{{ invoice.auditData.invoicePerLoad }}</span></div>
            <div fxFlex="4"><span>{{ invoice.auditData.requirePOD }}</span></div>
            <div fxFlex="4"><span>{{ invoice.auditData.requireBOL }}</span></div>
            <div fxFlex="9"><span>{{ invoice.auditData.requirePhysicalPOD }}</span></div>
            <div fxFlex="9"><span>{{ invoice.auditData.attachTransDetail }}</span></div>
            <div fxFlex="7"><span>{{ invoice.auditData.attachAcctDistRpt }}</span></div>
            <div fxFlex="4"><span>{{ invoice.auditData.attachPOD }}</span></div>
            <div fxFlex="4"><span>{{ invoice.auditData.attachBOL }}</span></div>
            <div fxFlex="19"><span>{{ invoice.auditData.requireManualInvoiceReview }}</span></div>
            <div fxFlex="9"><span>{{ invoice.auditData.nextInvoiceDate | date: 'MM/dd/yyyy' }}</span></div>
          </div>
          <mat-divider></mat-divider>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #noAuditTrailInformation>
    <span>No Audit History Available</span>
  </ng-template>
  <br>
  <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5pt">
    <button mat-button type="button" color="warn" [mat-dialog-close]="false">
      <mat-icon class="material-icons-outlined text-red">cancel</mat-icon>
      Exit
    </button>
  </div>
</div>
<app-loading fxLayout="row" fxLayoutAlign="center center" *ngIf="isLoading" [isRelative]="true"></app-loading>

